import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AtualizacoesService } from '../atualizacoes.service';

@Component({
  selector: 'app-agendar-atualizacao',
  templateUrl: './agendar-atualizacao.component.html',
  styleUrls: ['./agendar-atualizacao.component.css']
})
export class AgendarAtualizacaoComponent implements OnInit {

  dataSelecionada: string;
  valorId: any;
  username: any;

  constructor(private service: AtualizacoesService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.username = this.service.getUsername();
    this.requisicao();
  }

  ngOnInit() {
  }

  agendar() {
    if (this.dataSelecionada == undefined) {
      const data = new Date();
      const dia = ("0" + data.getDate()).slice(-2);
      const mes = ("0" + (data.getMonth() + 1)).slice(-2);
      const ano = data.getFullYear();
      const hora = ("0" + data.getHours()).slice(-2);
      const minuto = ("0" + data.getMinutes()).slice(-2);

      this.dataSelecionada = dia + "/" + mes + "/" + ano + " " + hora + ":" + minuto;
    } else {
      const dataOriginal = new Date(this.dataSelecionada);
      const dataFormatada = dataOriginal.toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });

      this.dataSelecionada = dataFormatada;
    }

    this.config.data.chave.forEach(element => {
      this.service.atualizarVersao(element.id_update_portal, this.username, this.dataSelecionada).subscribe(() => {
        this.ref.close();
      });
    });

  }

  onDateSelect(event: any) {
    this.dataSelecionada = event;
  }

  requisicao() {
    this.service.agendamento().subscribe(res => {
      if (res[0] != undefined) {
        this.valorId = res[0].id_update_portal;
      }
    });
  }
}
